<template>
  <div class="search__wrp">
    <div class="search__input">
      <span class="form__input-wrp">
        <input
          placeholder="请输入企业全称"
          type="search"
          class="form__input"
          ref="input"
          :readonly="readonly"
          v-model="keyword"
          v-on:keyup.enter.prevent="onEnter"
          v-on:keyup.up.prevent="selectItem(-1)"
          v-on:keyup.down.prevent="selectItem(1)"
          v-on:blur="onBlur"
        />
      </span>
    </div>
    <div class="reco-list__wrp" v-show="enterprises.length" ref="list">
      <ul class="reco__list">
        <li
          class="reco__item"
          v-for="(enterprise, index) in enterprises"
          :key="enterprise.name"
          @click="onClick(index)"
          :class="{'selected':selection==index}"
        >
          <div
            class="reco-item__desc"
            v-html="enterprise.name"
          ></div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: String,
    readonly: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      keyword: this.value,
      enterprises: [],
      selection: null,
    };
  },
  watch: {
    keyword(val) {
      if (val) {
        if (this.$refs.input == document.activeElement) {
          this.search(val);
        }
      } else {
        this.resetResultList();
      }
    },
  },
  methods: {
    search() {
      var me = this;
      setTimeout(function () {
        if (!me.searching && me.keyword && me.keyword.length > 2) {
          me.searching = true;
          me.$ajax({
            url: me.$url.api + "/api/account/company/qcc_search",
            params: {
              keyword: me.keyword
            },
          })
            .then(function (res) {
              me.searching = false;
              if (res.data) {
                me.enterprises = res.data.data || [];
                me.selection = null;
              }
            })
            .catch(function () {
              me.searching = false;
            });
        }
      }, 100);
    },
    resetResultList() {
      var me = this;
      me.enterprises = [];
      me.selection = null;
    },
    onEnter() {
      var me = this,
        keyword = me.keyword;
      if (keyword && me.selection != null) {
          me.select(me.selection);
      }
    },
    onClick(index) {
      this.select(index);
    },
    select(index) {
        var me = this,
            selected = me.enterprises[index];
        me.$refs.input.blur();
        me.keyword = selected.name;
        me.$emit("input", selected.name);
        me.$emit("select", selected);
        me.resetResultList();
    },
    selectItem(step) {
      var me = this,
        index,
        enterprises = me.enterprises;
      if (me.selection == null) {
        if (step < 0) {
          index = enterprises.length - 1;
        } else {
          index = 0;
        }
      } else {
        index = me.selection + step;
        if (index < 0) {
          index = enterprises.length - 1;
        } else if (index >= enterprises.length) {
          index = 0;
        }
      }

      me.selection = index;
      if (index > 3) {
        me.$refs.list.scrollTop = (index - 3) * 39;
      } else {
        me.$refs.list.scrollTop = 0;
      }
    },
    onBlur() {
      var me = this;
      setTimeout(function () {
        me.resetResultList();
      }, 200);
    },
  },
};
</script>

<style>
.search__wrp {
  display: inline-block;
  vertical-align: middle;
  position: relative;
}

.search__wrp .search__input .form__input{
  width: 100%;
}

.reco-list__wrp {
  position: absolute;
  z-index: 99999;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  left: -1px;
  right: -1px;
  top: 101%;
  max-height: 300px;
  overflow: auto;
}

.reco__list {
  padding: 0;
  margin: 0;
}

.reco__item {
  padding: 10px;
}

.reco__item:hover, .reco__item.selected {
  background: rgb(238, 238, 238);
  cursor: pointer;
}

.reco-item__desc {
  text-align: left;
  color: #888;
  word-wrap: break-word;
  word-break: break-all;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-height: 1.42;
  max-height: 2.84em;
}
</style>


// WEBPACK FOOTER //
// src/components/conenter/SearchBox.vue